export default "__VITE_ASSET__7ZD0QaVX__"